import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed, watch } from "vue";
import { appStore, viewApiStore, documentSaveStore } from "@/hooks";
import {
  ArtifactInput,
  ArtifactTypeInput,
  FlexBox,
  SwitchInput,
  TextButton,
  PanelCard,
  TextInput,
  DetailsPanel,
} from "@/components/common";


/**
 * Allows for creating and editing views.
 */
const __default__ = {
  name: "ViewPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = computed(() => documentSaveStore);
const isUpdate = computed(() => documentSaveStore.isUpdate);
const canSave = computed(() => documentSaveStore.canSave);
const nameError = computed(() => documentSaveStore.nameError);
const editedDocument = computed(() => documentSaveStore.editedDocument);
const includeChildren = computed(() => documentSaveStore.includeChildren);

/**
 * Resets the document fields when opened.
 */
function handleReset(): void {
  documentSaveStore.resetDocument();
}

/**
 * Closes the document panel.
 */
function handleClose() {
  appStore.close("detailsPanel");
}

/**
 * Generates artifacts to save on this document.
 */
function handleSaveTypes() {
  documentSaveStore.updateArtifacts();
}

/**
 * Generates child artifacts to save on this document.
 */
function handleSaveChildren() {
  documentSaveStore.updateChildArtifacts();
}

/**
 * Attempts to save the document.
 */
function handleSubmit() {
  viewApiStore.handleSave({
    onSuccess: () => handleClose(),
  });
}

/**
 * Attempts to delete the document after confirming.
 */
function handleDelete() {
  viewApiStore.handleDelete({
    onSuccess: () => handleClose(),
  });
}

watch(() => documentSaveStore.baseDocument, handleReset);

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!

  return (_openBlock(), _createBlock(_unref(DetailsPanel), {
    panel: "document",
    onOpen: handleReset
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(PanelCard), {
        title: "Save View",
        borderless: ""
      }, {
        actions: _withCtx(() => [
          _createVNode(_unref(FlexBox), {
            "full-width": "",
            justify: "between"
          }, {
            default: _withCtx(() => [
              (isUpdate.value)
                ? (_openBlock(), _createBlock(_unref(TextButton), {
                    key: 0,
                    text: "",
                    label: "Delete",
                    icon: "delete",
                    "data-cy": "button-document-delete",
                    onClick: handleDelete
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_q_space),
              _createVNode(_unref(TextButton), {
                disabled: !canSave.value,
                label: "Save",
                icon: "save",
                "data-cy": "button-document-save",
                onClick: handleSubmit
              }, null, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(TextInput), {
            modelValue: editedDocument.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editedDocument.value.name) = $event)),
            label: "Name",
            "error-message": nameError.value,
            "data-cy": "input-document-name"
          }, null, 8, ["modelValue", "error-message"]),
          _createVNode(_unref(ArtifactTypeInput), {
            modelValue: store.value.includedTypes,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((store.value.includedTypes) = $event)),
            multiple: "",
            label: "Include Artifact Types",
            class: "q-mb-md",
            "data-cy": "input-document-include-types",
            onBlur: handleSaveTypes
          }, null, 8, ["modelValue"]),
          _createVNode(_unref(ArtifactInput), {
            modelValue: editedDocument.value.artifactIds,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editedDocument.value.artifactIds) = $event)),
            multiple: "",
            label: "Artifacts",
            class: "q-mb-md",
            "data-cy": "input-document-artifacts"
          }, null, 8, ["modelValue"]),
          _createVNode(_unref(SwitchInput), {
            modelValue: store.value.includeChildren,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((store.value.includeChildren) = $event)),
            label: "Include artifact children",
            class: "q-mb-md",
            "data-cy": "button-document-include-children"
          }, null, 8, ["modelValue"]),
          (includeChildren.value)
            ? (_openBlock(), _createBlock(_unref(ArtifactTypeInput), {
                key: 0,
                modelValue: store.value.includedChildTypes,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((store.value.includedChildTypes) = $event)),
                multiple: "",
                label: "Include Child Types",
                class: "q-mb-md",
                "data-cy": "input-document-include-child-types",
                onBlur: handleSaveChildren
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (includeChildren.value)
            ? (_openBlock(), _createBlock(_unref(ArtifactInput), {
                key: 1,
                modelValue: store.value.childIds,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((store.value.childIds) = $event)),
                multiple: "",
                label: "Child Artifacts",
                class: "q-mb-md",
                "data-cy": "input-document-child-artifacts"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})